import axios from "axios";
import * as Sentry from "@sentry/react";
export async function getGoogleUrl(): Promise<string | null> {
    try {
        const googleRedirectURl = await axios.get(`${process.env.REACT_APP_API_URL}/google`);
        return googleRedirectURl.data.googleAuthUrl;
    } catch (error) {
        Sentry.captureException(error);
        return null;
    }
}
